import {axios} from '../../services/axios';

export default function getAppAuthByCompanyID(companyID) {
    return axios.get(`/appauth/company/${companyID}`);
}
